import { gql } from '@apollo/client';

export const FIND_STRATEGY_PEOPLE_BY_STRATEGY = gql`
  query FindStrategyPeopleByStrategy($uuid: ID!) {
    findStrategyPeopleByStrategy(uuid: $uuid) {
      summary
      uuid
    }
  }
`;

export const UPDATE_STRATEGY_PEOPLE = gql`
  mutation UpdateStrategyPeople($data: UpdateStrategyPeopleInput!) {
    updateStrategyPeople(data: $data) {
      summary
      uuid
    }
  }
`;

export const FIND_ALL_PEOPLE = gql`
  query FindAllPeople {
    findAllPeople {
      uuid
      functionName
      employeesRequired
      numberToHire
      hiringLeadTime
      qualificationRequired
    }
  }
`;

export const FIND_ALL_PEOPLE_BY_STRATEGY_PEOPLE = gql`
  query FindAllPeopleByStrategyPeople($uuid: ID!) {
    findAllPeopleByStrategyPeople(uuid: $uuid) {
      employeesRequired
      functionName
      hiringLeadTime
      numberToHire
      qualificationRequired
      uuid
    }
  }
`;

export const CREATE_PEOPLE = gql`
  mutation People($data: CreatePeopleInput!) {
    createPeople(data: $data) {
      employeesRequired
      functionName
      hiringLeadTime
      numberToHire
      qualificationRequired
      uuid
    }
  }
`;

export const UPDATE_PEOPLE = gql`
  mutation People($data: UpdatePeopleInput!) {
    updatePeople(data: $data) {
      employeesRequired
      functionName
      hiringLeadTime
      numberToHire
      qualificationRequired
      uuid
    }
  }
`;

export const DELETE_PEOPLE = gql`
  mutation DeletePeople($uuid: ID!) {
    deletePeople(uuid: $uuid) {
      employeesRequired
      functionName
      hiringLeadTime
      numberToHire
      qualificationRequired
      uuid
    }
  }
`;
